import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
  TimerModule,
} from '@shared/components/games';
import { MorewordsMemoryControllerComponent } from './morewords-memory-controller/morewords-memory-controller.component';
import { MorewordsMemoryCorrectAnswerPreviewComponent } from './morewords-memory-preview/morewords-memory-answer-preview/morewords-memory-answer-preview.component';
import { MorewordsMemoryExamplePreviewComponent } from './morewords-memory-preview/morewords-memory-example-preview/morewords-memory-example-preview.component';
import { MorewordsMemoryParametersPreviewComponent } from './morewords-memory-preview/morewords-memory-parameters-preview/morewords-memory-parameters-preview.component';
import { MorewordsMemoryUserAnswerPreviewComponent } from './morewords-memory-preview/morewords-memory-user-answer-preview/morewords-memory-user-answer-preview.component';
import { MorewordsMemorySettingsComponent } from './morewords-memory-settings/morewords-memory-settings.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { PicturesFilterModule } from '@shared/components/games/pictures-filter/pictures-filter.module';

@NgModule({
  declarations: [
    MorewordsMemoryControllerComponent,
    MorewordsMemorySettingsComponent,
    MorewordsMemoryCorrectAnswerPreviewComponent,
    MorewordsMemoryExamplePreviewComponent,
    MorewordsMemoryParametersPreviewComponent,
    MorewordsMemoryUserAnswerPreviewComponent,
  ],
  exports: [
    MorewordsMemoryControllerComponent,
    MorewordsMemorySettingsComponent,
    NgSelectModule,
    MorewordsMemoryCorrectAnswerPreviewComponent,
    MorewordsMemoryExamplePreviewComponent,
    MorewordsMemoryParametersPreviewComponent,
    MorewordsMemoryUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    TimerModule,
    NgSelectModule,
    FormFieldModule,
    TextsFilterComponent,
    GamesSharedModule,
    AnswerEntryFormComponent,
    GameInputComponent,
    PicturesFilterModule,
  ],
})
export class MorewordsMemoryModule {}
